const config = {
    app: {
        port: import.meta.env.VITE_PORT,
        node_env: import.meta.env.MODE,
    },
    aws: {
        region: import.meta.env.VITE_AWS_REGION,
        identityPoolId: import.meta.env.VITE_AWS_IDENTITY_POOL_ID,
        endpoint: import.meta.env.VITE_AWS_ENDPOINT,
    },
    api: {
        common_api_host: import.meta.env.VITE_COMMON_API_HOST,
        flowing_web_url: import.meta.env.VITE_FLOWING_WEB_URL,
        flowing_spacehome_url: import.meta.env.VITE_FLOWING_SPACEHOME_URL,
        ladingpage_update_key: import.meta.env.VITE_LADINGPAGE_UPDATE_KEY,
        mall_api: import.meta.env.VITE_MALL_API_URL,
        user_api: import.meta.env.VITE_USER_API_URL,
        chat_api: import.meta.env.VITE_CHAT_API_URL,
        payment_api: import.meta.env.VITE_PAYMENT_API_URL,
        search_api: import.meta.env.VITE_SEARCH_API_URL,
        landing_api: import.meta.env.VITE_LANDING_API_URL,
        proxy_api: import.meta.env.VITE_PROXY_API_URL,
        common_api: import.meta.env.VITE_COMMON_API_URL,
        studio_api: import.meta.env.VITE_STUDIO_API_URL,
        default_api: import.meta.env.VITE_DEFAULT_API_URL,
        api_key: import.meta.env.VITE_API_KEY,
        api_secret: import.meta.env.VITE_API_SECRET,
        chat2_api: import.meta.env.VITE_CHAT2_API_URL,
        proxy2_api: import.meta.env.VITE_PROXY2_API_URL,
        agent_api: import.meta.env.VITE_AGENT_API_URL,
        matching_api: import.meta.env.VITE_MATCHING_API_URL,
    },
    url: {
        matching_url: import.meta.env.VITE_FLOWING_MATCHING_URL,
        studio_url: import.meta.env.VITE_FLOWING_STUDIO_URL,
        manager_url: import.meta.env.VITE_FLOWING_MANAGER_URL,
        chatting_url: import.meta.env.VITE_FLOWING_CHATTING_URL,
    },
    toss: {
        client_key: import.meta.env.VITE_TOSS_CLIENT_KEY,
    },
    nicepay: {
        client_key: import.meta.env.VITE_NICEPAY_CLIENT_KEY,
        f_merchant_key: import.meta.env.VITE_NICEPAY_FLOWING_MERCHANT_KEY,
        f_payment_mid: import.meta.env.VITE_NICEPAY_FLOWING_PAYMENT_MID,
        tp_merchant_key: import.meta.env.VITE_NICEPAY_TPKOREA_MERCHANT_KEY,
        tp_payment_mid: import.meta.env.VITE_NICEPAY_TPKOREA_PAYMENT_MID,
    },
    ga: {
        tracking_id: import.meta.env.VITE_GA_TRACKING_ID,
    },
    social: {
        naver_client_id: import.meta.env.VITE_NAVER_CLIENT_ID,
        apple_client_id: import.meta.env.VITE_APPLE_CLIENT_ID,
        kakao_client_id: import.meta.env.VITE_KAKAO_CLIENT_ID,
        naver_redirect_url: import.meta.env.VITE_NAVER_REDIRECT_URL,
        apple_redirect_url: import.meta.env.VITE_APPLE_REDIRECT_URL,
        kakao_redirect_url: import.meta.env.VITE_KAKAO_REDIRECT_URL,
    },
};

export default config;
